import styles from "./SelectTextQuestion.module.css";
import { useTranslation } from "react-i18next";

// value shape: { choice?: number, details?: { text?: string } }
export default function SelectTextQuestion({ details = {}, value, onChange }) {
    const { t } = useTranslation();
    const options = Array.isArray(details.options) ? details.options : [];
    const selected = typeof value?.choice === 'number' ? value.choice : 0; // 1-based index of option
    const text = value?.details?.text ?? "";

    const handleSelect = (e) => {
        const idx1 = Number(e.target.value);
        onChange?.({ choice: idx1, details: { text } });
    };

    const handleText = (e) => {
        const next = e.target.value;
        onChange?.({ choice: selected, details: { text: next } });
    };

    return (
        <div className={styles.wrap}>
            <div className={styles.row}>
                <select className={styles.select} value={selected} onChange={handleSelect} aria-label={t('selectText.selectLabel', { defaultValue: 'Wybierz opcję' })}>
                    <option value={0} disabled>{t('selectText.placeholder', { defaultValue: '— wybierz —' })}</option>
                    {options.map((opt, i) => {
                        const optLabel = typeof opt === 'object' && opt !== null ? opt.label : opt;
                        return (
                        <option key={i + 1} value={i + 1}>{optLabel}</option>
                        );
                    })}
                </select>
                {/* <input
                    className={styles.input}
                    type="text"
                    value={text}
                    onChange={handleText}
                    placeholder={t('selectText.textPlaceholder', { defaultValue: 'Wpisz tekst' })}
                /> */}
            </div>
        </div>
    );
}
